import { FC } from 'react'

import { IconTelegram } from 'components/icons/telegram'
import { IconFacebook } from 'components/icons/facebook'
import { useAppContext } from 'context/app-context'
import { IconYoutube } from 'components/icons/youtube'
import { IconInstagram } from 'components/icons/instagram'
import { Container } from 'components/container'
import { IconTwitter } from 'components/icons/twitter'
import {
  About,
  Authors,
  Copyright,
  Heading,
  Social,
  SocialLinks,
  StyledFooter,
} from './styled'
import { config } from 'config'

type Props = {}

const socialConfig = {
  facebook: {
    icon: <IconFacebook />,
    link: 'https://www.facebook.com/radiosvoboda.org',
    linkRu: 'https://www.facebook.com/krymrealii',
  },
  twitter: {
    icon: <IconTwitter />,
    link: 'https://twitter.com/radiosvoboda',
    linkRu: 'https://x.com/krymrealii',
  },
  youtube: {
    icon: <IconYoutube />,
    link: 'https://www.youtube.com/channel/UC7qnYpVcuFbURi3E2E6_f6Q',
    linkRu: 'https://www.youtube.com/channel/UCTxc3zFdloSLhqPd6mfIMKA',
  },
  instagram: {
    icon: <IconInstagram />,
    link: 'https://www.instagram.com/radio.svoboda/',
    linkRu: 'https://www.instagram.com/krymrealii/',
  },
  telegram: {
    icon: <IconTelegram />,
    link: 'https://telegram.me/svoboda_radio',
    linkRu: 'https://t.me/krymrealii',
  },
}

const parseSocial = () => (
  <SocialLinks>
    {Object.keys(socialConfig).map(k => {
      const networkConfig = socialConfig[k as keyof typeof socialConfig]

      return networkConfig ? (
        <li key={k}>
          <a
            href={
              config.language === 'ru'
                ? networkConfig.linkRu
                : networkConfig.link
            }
            target="_blank"
            rel="noreferrer"
          >
            {networkConfig.icon}
          </a>
        </li>
      ) : null
    })}
  </SocialLinks>
)

export const Footer: FC<Props> = () => {
  const { strings } = useAppContext()

  return (
    <Container>
      <StyledFooter>
        <Authors>
          <Heading>{strings.footer_created_by_title}</Heading>
          <p>{strings.footer_created_by_content}</p>
        </Authors>
        <Social>
          <Heading>{strings.footer_follow_us}</Heading>
          {parseSocial()}
        </Social>
        <About>
          <Heading>{strings.footer_about_title}</Heading>
          <p>{strings.footer_about_content}</p>
        </About>
        <Copyright>
          {strings.footer_copyright.replace(
            '{year}',
            new Date().getFullYear().toString()
          )}
        </Copyright>
      </StyledFooter>
    </Container>
  )
}
